import React from 'react';
import PropTypes from 'prop-types';
import { MATERIAL_TABLE_TYPE_VIEW } from '../utils/constants';

const RenderTooltipCellByTypeView = ({ field, typeView, rowData }) => {
  return (
    <>
      {typeView !== MATERIAL_TABLE_TYPE_VIEW.GROUP ? (
        <span className="tooltip-test" title={field}>
          {field}
        </span>
      ) : (
        rowData
      )}
    </>
  );
};

RenderTooltipCellByTypeView.propTypes = {
  rowData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(PropTypes.shape),
  ]).isRequired,
  field: PropTypes.string,
  typeView: PropTypes.string,
};

RenderTooltipCellByTypeView.defaultProps = {
  typeView: MATERIAL_TABLE_TYPE_VIEW.ROW,
  field: '',
};

export default RenderTooltipCellByTypeView;
